export default {
    header: "Sikeresen kijelentkezett",
    message: ""
}